import { flattenObject, parseJson } from '../lib/fieldInference';

const MAX_GUIDED_FIELDS = 12;

// Field-by-field editor over a flattened JSON payload — originally built for
// MessageSchemaManagerPage's "create schema from sample" flow, now also used by
// DocumentGenerateForm's guided tab. Falls back to a plain textarea for XML or payloads that
// don't parse as a JSON object, since there's nothing to flatten in that case.
export function GuidedPayloadEditor({ sample, setSample, format }: { sample: string; setSample: (value: string) => void; format: 'JSON' | 'XML' }) {
  const parsed = parseJson(sample);
  if (format === 'XML' || !parsed) {
    return <label className="full-width"><span>Example payload</span><textarea rows={14} value={sample} onChange={(event) => setSample(event.target.value)} /></label>;
  }

  const flattened = Object.entries(flattenObject(parsed));

  const update = (path: string[], value: string) => {
    const next = structuredClone(parsed) as Record<string, unknown>;
    let cursor: Record<string, unknown> = next;
    for (const segment of path.slice(0, -1)) cursor = cursor[segment] as Record<string, unknown>;
    cursor[path[path.length - 1]] = value;
    setSample(JSON.stringify(next, null, 2));
  };

  return (
    <div className="full-width">
      <div className="guided-editor">
        {flattened.slice(0, MAX_GUIDED_FIELDS).map(([path, value]) => (
          <label key={path}>
            <span>{path}</span>
            <input value={String(value)} onChange={(event) => update(path.split('.'), event.target.value)} />
          </label>
        ))}
      </div>
      {flattened.length > MAX_GUIDED_FIELDS ? (
        <p className="field-warning">
          {flattened.length - MAX_GUIDED_FIELDS} more field{flattened.length - MAX_GUIDED_FIELDS === 1 ? '' : 's'} in this
          payload aren&apos;t shown here — switch to Raw JSON to edit them directly.
        </p>
      ) : null}
    </div>
  );
}
